import { NavLink } from "react-router-dom";

const LINKS: Array<{ to: string; label: string }> = [
  { to: "/reports/overview", label: "Overview" },
  { to: "/reports/sales-by-store", label: "Sales by store" },
  { to: "/reports/machines-left-complete", label: "Machines left complete" },
  { to: "/reports/errors", label: "Errors" },
  { to: "/reports/downtime", label: "Downtime" },
];

export default function ReportsSubNav() {
  return (
    <nav className="sq-chips" aria-label="Reports">
      {LINKS.map((link) => (
        <NavLink key={link.to} to={link.to} className="sq-chip">
          {link.label}
        </NavLink>
      ))}
    </nav>
  );
}
